"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSteps = exports.MainStepsContext = void 0;
var react_1 = __importStar(require("react"));
var StepsUpperBar_1 = __importDefault(require("./components/StepsUpperBar/StepsUpperBar"));
var StepsUpperBarNode_1 = __importDefault(require("./components/StepsUpperBar/StepsUpperBarNode"));
exports.MainStepsContext = react_1.default.createContext({});
var VSteps = function (props) {
    var _a = (0, react_1.useState)(0), currentStep = _a[0], setCurrentStep = _a[1];
    var totalSteps = react_1.default.Children.count(props.children);
    var findStepKey = function () {
        var r;
        react_1.default.Children.forEach(props.children, function (child, index) {
            if (index === currentStep) {
                r = child.props.stepKey;
                return;
            }
        });
        return r;
    };
    var goToPreviousStep = function () {
        currentStep > 0 && setCurrentStep(currentStep - 1);
        props.onChange && props.onChange(findStepKey(), 'previous');
    };
    var goToNextStep = function () {
        currentStep < totalSteps - 1 && setCurrentStep(currentStep + 1);
        props.onChange && props.onChange(findStepKey(), 'next');
    };
    var upperBarNodes = [];
    var children = react_1.default.Children.map(props.children, function (child, index) {
        upperBarNodes.push(react_1.default.createElement(StepsUpperBarNode_1.default, { key: "StepNode".concat(index), index: index + 1, title: child.props.title, icon: child.props.icon, description: child.props.description, currentStep: currentStep, isActive: index === currentStep, isDone: index < currentStep }));
        return react_1.default.cloneElement(child, {
            isActive: index === currentStep,
            displayPrevious: currentStep > 0,
            displayNext: currentStep < totalSteps - 1,
            displaySubmit: currentStep === totalSteps - 1,
            goToPreviousStep: function () { return goToPreviousStep(); },
            goToNextStep: function () { return goToNextStep(); }
        });
    });
    return (react_1.default.createElement(exports.MainStepsContext.Provider, { value: __assign({}, props) }, children ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StepsUpperBar_1.default, null, upperBarNodes),
        react_1.default.createElement(react_1.default.Fragment, null, children))) : (react_1.default.createElement(react_1.default.Fragment, null, 'There are no steps'))));
};
exports.VSteps = VSteps;
